import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import koffie from '../../../assets/koffie.png'
import thee from '../../../assets/thee.png'
import reiniging from '../../../assets/Non-food.png'
import extra from '../../../assets/Food.png'

import { DropDown, DropDownItem, ImageContainer } from './styles.js'

class AssortimentMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  render() {
    const current = this.props.history.location.pathname

    return (
      <DropDown>
        <DropDownItem current={current === '/assortiment/koffie'}>
          <Link to="/assortiment/koffie" onClick={this.handleClick.bind(this)}>
            <ImageContainer>
              <div style={{ backgroundImage: `url(${koffie})` }} />
            </ImageContainer>
            <p>Koffie</p>
          </Link>
        </DropDownItem>

        <DropDownItem current={current === '/assortiment/thee'}>
          <Link to="/assortiment/thee" onClick={this.handleClick.bind(this)}>
            <ImageContainer>
              <div style={{ backgroundImage: `url(${thee})` }} />
            </ImageContainer>
            <p>Thee</p>
          </Link>
        </DropDownItem>

        <DropDownItem current={current === '/assortiment/food'}>
          <Link to="/assortiment/food" onClick={this.handleClick.bind(this)}>
            <ImageContainer>
              <div style={{ backgroundImage: `url(${extra})` }} />
            </ImageContainer>
            <p>Food</p>
          </Link>
        </DropDownItem>

        <DropDownItem current={current === '/assortiment/non-food'}>
          <Link to="/assortiment/non-food" onClick={this.handleClick.bind(this)}>
            <ImageContainer>
              <div style={{ backgroundImage: `url(${reiniging})` }} />
            </ImageContainer>
            <p>Non-food</p>
          </Link>
        </DropDownItem>
      </DropDown>
    )
  }
}

export default withRouter(AssortimentMenu)



// WEBPACK FOOTER //
// ./src/components/Header/AssortimentMenu/index.js